import { useEffect, useRef, useState } from 'react';
import { Download, FileSpreadsheet, FileText, ChevronDown } from 'lucide-react';
import { http } from '../lib/api';

export function ExportMenu({ collection, testId = 'export-button', formats = ['xlsx', 'pdf', 'csv'], label = 'Dışa aktar' }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState('');
  const ref = useRef();
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close); return () => document.removeEventListener('mousedown', close);
  }, []);
  const download = async (format) => {
    setBusy(format);
    try {
      const r = await http.get(`/export/${collection}`, { params: { format }, responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement('a'), { href: url, download: `${collection}-${new Date().toISOString().slice(0, 10)}.${format}` });
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      setOpen(false);
    } finally { setBusy(''); }
  };
  return <div className="export-wrap" ref={ref}>
    <button className="secondary-btn" onClick={() => setOpen(!open)} data-testid={testId}><Download size={16} /> {label} <ChevronDown size={14} /></button>
    {open && <div className="export-menu" data-testid="export-menu">
      {formats.includes('xlsx') && <button onClick={() => download('xlsx')} disabled={!!busy} data-testid="export-xlsx"><FileSpreadsheet size={15} /> Excel (.xlsx)</button>}
      {formats.includes('pdf') && <button onClick={() => download('pdf')} disabled={!!busy} data-testid="export-pdf"><FileText size={15} /> PDF</button>}
      {formats.includes('csv') && <button onClick={() => download('csv')} disabled={!!busy} data-testid="export-csv"><FileSpreadsheet size={15} /> CSV</button>}
    </div>}
  </div>;
}
